/**
 * Single source of truth for the order edit permission matrix in the UI.
 * Mirrors the server-side RLS/RPC boundary (order_lines_update, tightened in
 * migration 20261021000000, plus the update_order_patient_name and
 * archive_order_file RPCs): admins edit at any status; a clinic podiatrist only
 * while BOTH the order and the primary line are draft/submitted. The server is
 * authoritative; this helper keeps the UI in agreement so controls are hidden
 * or disabled to match what the API would allow.
 */
export const EDITABLE_STATUSES_FOR_PODIATRIST: ReadonlySet<string> = new Set([
  'draft',
  'submitted',
]);

export function canEditOrderAtStatus(
  isAdmin: boolean,
  orderStatus: string,
  lineStatus: string,
): boolean {
  if (isAdmin) return true;
  return (
    EDITABLE_STATUSES_FOR_PODIATRIST.has(orderStatus) &&
    EDITABLE_STATUSES_FOR_PODIATRIST.has(lineStatus)
  );
}

/** order_status values at or beyond production, for the admin re-send nudge. */
const IN_PRODUCTION_OR_LATER: ReadonlySet<string> = new Set([
  'in_production',
  'in_delivery',
  'delivered',
  'returned',
]);

export function isInProductionOrLater(orderStatus: string): boolean {
  return IN_PRODUCTION_OR_LATER.has(orderStatus);
}

export const IN_PRODUCTION_WARNING =
  "This order is already in production; changes here won't reach the supplier unless you regenerate the Excel / draft email.";
